module.exports = __webpack_public_path__ + "static/media/Slide2.09970807.jpg";